export enum DeviceModelState {
	ACTIVE = 'ACTIVE',
	ARCHIVED = 'ARCHIVED'
}
